module.exports = "https://img.xiyuyouxi.com/saas/img/dayicon.7a17e6a2.png";